import React from "react";
import { AppNavFactory } from "./components";
import "./styles.css";

export default function MainNav({ tree }) {
  const { technik, organisation } = tree || {};
  if (!technik || !organisation) {
    return null;
  }
  const AppNav = AppNavFactory(technik, organisation);
  return (
    <div className="main-nav level-0">
      <AppNav isVisible />
    </div>
  );
}
